/**
 * Out-of-React navigation bridge for LLM-originated `ide.*` ops
 * (contacts handoff §2.5). Platform-ops handlers are plain functions
 * dispatched from the gateway event stream — outside any Router
 * context — so a component inside the Router installs the real
 * `navigate` here (NavigationBridgeInstaller) and handlers call
 * `navigateTo`. Never mutates data — navigation only.
 */

type NavigateFn = (path: string) => void;

let navigator: NavigateFn | null = null;

export function setNavigator(fn: NavigateFn | null): void {
  navigator = fn;
}

/** Navigate the SPA; returns false when no Router is mounted yet. */
export function navigateTo(path: string): boolean {
  if (!navigator) return false;
  navigator(path);
  return true;
}

/** Test-only. */
export function _resetNavigatorForTest(): void {
  navigator = null;
}
